import { Injectable } from '@angular/core';

import { FilterDetails } from './filterDetails';

@Injectable({ providedIn: 'root' })
export class Filters {
  public details: FilterDetails[];
}
